<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {}

</script>

<style>

  html {
    position: relative;
    overflow-x: hidden;
  }

  body {
    margin: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    position: relative;
    overflow-x: hidden;
    /* background-color: #F1F1F1; */
    background-color: rgba(241, 241, 241, 0.42);
    font-size: 2rem;
    font-family: -apple-system, BlinkMacSystemFont,
                 'avenir next', avenir,
                 helvetica, 'helvetica neue',
                 Ubuntu,
                 'segoe ui', arial,
                 sans-serif;
  }

  #app {
    overflow: hidden;
  }

  .block-heading-font-style {
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    display: block;
    font-size: 28px;
    letter-spacing: 2px;
    color: #00BFBD;
    text-align: center;
    font-weight: normal;
  }

  .block-subheading-font-style {
    font-family: 'Work Sans', sans-serif;
    color: #333;
    width: 50%;
    text-align: center;
    margin: 0 auto;
    padding: 2px;
    font-size: 14px;
  }

  @media only screen and (max-width: 800px) {
    .block-subheading-font-style {
      width: 80%;
    }
  }

  @media only screen and (max-width: 650px) {
    .block-subheading-font-style {
      width: 90%;
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?115dc0fb